import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { ContentIntelligenceRouterProps } from '../src/ContentIntelligenceRouter.tsx';

/**
 * The package's only public export. Loads `ContentIntelligenceRouter`, which then picks the landing
 * page or one of the three sub-views based on the URL's `?view=` param.
 *
 * `LoadablePaint` (not `LoadableAfterPaint`) because this is the main body of the route and must
 * hydrate immediately — `AFTER_PAINT` would wrap it in `LoadablePlaceholderServer` and defer client
 * chunk evaluation past first paint.
 */
export const ContentIntelligenceLoader: LoadableType<ContentIntelligenceRouterProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContentIntelligence" */ '../src/ContentIntelligenceRouter.tsx'
				)
			).ContentIntelligenceRouter,
	});
